import { bulletListClassName } from '@/pages/pii-training/piiTraining.styles';
import type { HeadingBulletListProps } from '@/pages/pii-training/piiTraining.types';
import { Stack, Text } from '@careflux/primitives';

/** Heading followed by a bulleted list, reused by both content steps. */
export const HeadingBulletList = ({ heading, items }: HeadingBulletListProps) => (
  <Stack gap="sm">
    <Text asChild weight="semibold">
      <p>{heading}</p>
    </Text>
    <Stack asChild gap="xs">
      <ul className={bulletListClassName}>
        {items.map((item) => (
          <Text asChild key={item}>
            <li>{item}</li>
          </Text>
        ))}
      </ul>
    </Stack>
  </Stack>
);
